<template>
    <div class="automation-block-editor sleep">
        <div class="editor-row customize-editor-minimize">
            <div class="editor-row-title">{{ $t("message.platform") }}</div>
            <div class="btnGroup">
                <SupsisButton
                    v-for="platform in ['supsis', 'email', 'whatsapp']"
                    :classNames="clone.platform === platform ? 'btnGroupItem selected' : 'btnGroupItem '"
                    :primary="clone.platform === platform"
                    :ghost="clone.platform !== platform"
                    @click="clone.platform = platform"
                    small
                    :key="platform"
                >
                    {{ platform }}
                </SupsisButton>
            </div>
        </div>
        <div class="editor-row customize-editor-minimize">
            <div class="editor-row-title">{{ $t("message.fullName") }}</div>
            <TiptapEditor
                :placeholder="$t('automation.nameSurname')"
                :show-attributes="true"
                :max-character-count="500"
                v-model="clone.fullname"
                automation-mode
            />
        </div>
        <div class="editor-row customize-editor-minimize">
            <div class="editor-row-title">{{ $t("message.email") }}</div>
            <TiptapEditor
                :placeholder="$t('message.email')"
                :show-attributes="true"
                v-model="clone.email"
                automation-mode
            />
        </div>
        <div class="editor-row customize-editor-minimize">
            <div class="editor-row-title">{{ $t("message.phone") }}</div>
            <small>{{ $t("automation.phone164") }}</small>
            <TiptapEditor
                :placeholder="$t('message.phoneNumber')"
                :show-attributes="true"
                v-model="clone.phone"
                automation-mode
            />
        </div>
        <div class="editor-row customize-editor-minimize" v-if="clone.platform === 'whatsapp'">
            <div class="editor-row-title">{{ $t("automation.whichWpChannels") }}</div>
            <CustomPicker
                v-model="clone.channelIds"
                id-key="_id"
                label-key="name"
                :items="whatsappChannels"
                title="Whatsapp Kanalı Seç"
                multiple
            />
        </div>
        <div class="editor-row-title">Contact Properties</div>
        <div class="editor-row customize-editor-minimize" v-for="prop in allContactProperties" :key="prop._id">
            <div class="editor-row-title">{{ prop.label }}</div>
            <TiptapEditor
                :placeholder="prop.label"
                :show-attributes="true"
                v-model="clone.contactProperties[prop._id]"
                automation-mode
            />
        </div>
    </div>
</template>

<script>
import log2 from "../../../../../../../utils/log2";
import _ from "lodash";
import TiptapEditor from "../../../../../Chatbot/pages/dashboard/common/TiptapEditor.vue";
import SupsisButton from "../../../../../Settings/components/SupsisButton.vue";
import CustomPicker from "../../../../../../../components/pickers/CustomPicker.vue";
import { mapState } from "vuex";

const log = log2("CreateContact");
export default {
    name: "CreateContact",
    components: { CustomPicker, SupsisButton, TiptapEditor },
    props: ["value"],
    computed: {
        ...mapState({
            whatsappChannels: (state) =>
                state.channel.channels.filter((channel) => channel.type.startsWith("whatsapp")),
            allContactProperties: (state) => state.contactProperty.data || [],
        }),
    },
    data() {
        const clone = _.cloneDeep(this.value) || {
            fullname: "",
            email: "",
            phone: "",
            platform: "",
            channelIds: [],
            contactProperties: {},
        };

        if (!Array.isArray(clone.channelIds)) {
            clone.channelIds = [];
        }
        clone.contactProperties = clone.contactProperties || {};

        return {
            clone,
        };
    },
    methods: {},
    created() {
        const attrs = this.allContactProperties || [];
        attrs.forEach((prop) => {
            if (!this.clone.contactProperties[prop._id]) {
                this.clone.contactProperties[prop._id] = "";
            }
        });
    },
    watch: {
        clone: {
            deep: true,
            handler(newValue) {
                this.$emit("input", newValue);
            },
        },
    },
};
</script>

<style lang="scss">
.automation-block-editor.sleep {
    padding: 20px;
    display: flex;
    gap: 20px;
    flex-direction: column;

    section {
        width: 100%;
        display: flex;
        gap: 10px;
        flex-direction: column;
    }

    .editor-row {
        width: 100%;

        .editor-row-title {
            font-weight: bold;
            font-size: 16px;
        }
    }

    .btnGroup {
        display: flex;
        border: 1px solid var(--color-border-default);
        border-radius: 6px;
        background: var(--color-bg-neutral-default);
        margin: 2px 10px;
        padding: 2px;

        .btnGrupItem {
            &.selected {
                background: var(--color-bg-oncomponent-default);
                box-shadow: var(--shadow-interaction-200);
            }
        }

        .supsis-button {
            border: none !important;
            font-size: 13px;
            height: 25px;
        }
    }
}
</style>
